import constants from '../../../common/restService/constant'
import GatewayGet from '../CommonServices/GatewayGet'

let props = {}
let inputObj = {}
let InputJSONString = ''
props['query'] = constants.serviceRoot
props['headers'] = constants.serviceHeaders

export const GetUserDetails = async () => {
    try{
        let props = {};
        let inputObj = {};
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        inputObj["Activity"] = "GET_USER_DETAILS";
        inputObj["Input"] = "";
        props.input = inputObj;
        
     const result = await GatewayGet(props, props.input);
     return result
    }
    catch(error){
        console.log("error",error);
    }
}
